import { request } from './request';

// 获取编译版本号
export const getVersion = async (params = {}) => {
    const data = await request.get('/static/file/version.json', params, {
        baseURL: '/',
    });

    return data;
};

export const getImgs = async (params = {}) => {
    const data = await request.get('https://jsonplaceholder.typicode.com/photos?_page=1&_limit=10', params, {});

    return data;
};

//  文件上传
export const uploadFile = async (params = {}, options = {}) => {
    const data = await request.post('/v1/assets/upload-ref', params, options);

    return data;
};

// 每日领取
export const getReward = async (params = {}, options = {}) => {
    const data = await request.post('/v1/billing/reward/daily', params, options);

    return data;
};
